import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    console.log('Connected Stimulus controller');
    this.addEventListeners();
  }

  addEventListeners() {
    // Обрабатываем клик для Turbo-ссылок
    document.addEventListener("turbo:click", (e) => {
      const target = e.target;
      if (target.matches(".pagination a")) {
        // Если клик выполнен по пагинационной ссылке, запросим прокрутку вверх
        this.requestScrollToTop();
      }
    });

    // Обрабатываем загрузку Turbo-страницы
    document.addEventListener("turbo:load", () => {
      //console.log('Turbo page loaded');
      // Место для дополнительных действий после загрузки страницы, если они необходимы
    });
  }

  requestScrollToTop() {
    // Функция для прокрутки вверх
    window.scrollTo(0, 0);
    console.log('Scrolling to top');
  }
}
